import React from "react";
import { Route } from "react-router-dom";

const PrivateRoute = ({ history, component: Component, authed, device_id, ...rest }) => {
  if (!authed) {
    window.location.href = `${process.env.REACT_APP_CLOUDFUNCTION_URL}/authorize?device=${device_id}`;
  }

  return <Route {...rest} render={(props) => <Component authed={authed} {...props} />} />;
};

export default PrivateRoute;
